var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.stateStep, 'chip']},[_c('div',{staticClass:"number-step"},[_c('div',[_vm._v(" "+_vm._s(_vm.contentStep.step)+" ")])]),_c('div',{staticClass:"text-chip"},[_vm._v(" "+_vm._s(_vm.contentStep.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }